export default "__VITE_ASSET__DBpYJ7Lt__"